define(["data/config"], function(config) {
    var apply = function($element, params) {
        
        $element.on("click", function(ev) {
            toggle($element, params);
        });

        var toggle = function($element, params) {
            if ($(params.show).hasClass('u_hidden')) {
                $(params.show).removeClass('u_hidden');
                $(params.hide).addClass('u_hidden');
                if(params.texthide && params.textshow) {
                    $element.text(params.texthide);
                }
            }
            else if ($(params.hide).hasClass('u_hidden')) {
                $(params.hide).removeClass('u_hidden');
                $(params.show).addClass('u_hidden');
                if(params.texthide && params.textshow) {
                    $element.text(params.textshow);
                }
            }
        }
    };

    return {
        name: "uiInputToggler",
        defaultParameters: {
            show: "",
            hide: "",
            texthide: false,
            textshow: false,
        },
        apply: apply
    };
});
